/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path, Polyline, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function NyTimesLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle cx={168} cy={148} r={16} />
      <Path
        d="M205.57177,163.35784A80.00853,80.00853,0,1,1,127.92969,64"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M67.24858,91.86653A28.00107,28.00107,0,0,1,70,36L186,92a28,28,0,0,0,0-56"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Polyline
        points="48.589 154.315 127.93 112 127.93 224"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={91.92969}
        y1={131.2}
        x2={91.92969}
        y2={215.45913}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default NyTimesLogo;
